import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NotificationsService } from 'angular2-notifications';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { Subscription, timer } from 'rxjs';
import { AuthService } from '../../auth/auth.service';
import { LoggedInUserService } from '../../auth/logged.in.user';
import { PaymentStatus } from '../../models/subscriptions/subscription.enums';
import { PaymentService } from '../../services/payment.service';
import { RouterService } from '../../services/routerService';

@Component({
    selector: 'training-processing',
    template: '<div class= "modal inmodal in" id="payment-failed-modal" tabindex="-1" role="dialog" data-backdrop="static"><div class="modal-dialog"><div class="modal-content animated fadeIn"><div class="modal-header"><h4 class="modal-title">Card Payment Failed</h4></div><div class= "modal-body" >Sorry - your training payment has failed. Please re-enter your details and try again.<br/>If this error persists, please contact your card provider or a B2B system administrator.</div><div class= "modal-footer"><button type="button" class= "btn btn-success pull-right" (click)="redirectToPaymentPage()" >Ok</button></div></div></div></div>'
})
export class TrainingProcessingComponent implements OnInit {
    @BlockUI() blockUi: NgBlockUI;

    routeParamsSub: Subscription;

    private subscriptionId: number;
    private timerSub: Subscription;

    constructor(private routerService: RouterService, private route: ActivatedRoute,
        private paymentService: PaymentService, private notificationsService: NotificationsService,
        private readonly authService: AuthService, private readonly loggedInUserService: LoggedInUserService) {
        this.routerService.doNotAddCurrentPageToRouteStack();
        $('#payment-failed-modal').modal();
        $('#payment-failed-modal').modal('hide');
    }


    ngOnInit() {
        this.blockUi.start('Processing 3D secure confirmation. Please do not refresh this page.');

        if (this.routeParamsSub) {
            this.routeParamsSub.unsubscribe();
        }

        this.routeParamsSub = this.route.params.subscribe(params => {
            const id = +params['id'];

            this.timerSub = timer(5000).subscribe(() => {
                this.timerSub.unsubscribe();
                this.timerSub = null;

                this.paymentService.getPaymentStatus(id).subscribe((response: PaymentStatus) => {
                    switch (response) {
                        case PaymentStatus.Paid:
                            {
                                this.routerService.router.navigateByUrl(`/training/confirm/${id}`);
                                this.blockUi.stop();

                                this.notificationsService.success('Payment Successful',
                                    'Secure 3D authorisation successful and payment made.');

                                break;
                            }
                        case PaymentStatus.Pending:
                            {
                                this.tryAgain(id);
                                break;
                            }
                        default:
                            {
                                $('#payment-failed-modal').modal();
                                break;
                            }
                    }
                    this.blockUi.stop();
                },
                    () => {
                        this.blockUi.stop();
                    });
            });
        });
    }

    ngOnDestroy() {
        if (this.routeParamsSub) {
            this.routeParamsSub.unsubscribe();
        }
        if (this.timerSub) {
            this.timerSub.unsubscribe();
        }
    }

    tryAgain(id: number) {

        this.timerSub = timer(5000).subscribe(() => {
            this.timerSub.unsubscribe();
            this.timerSub = null;

            this.paymentService.getPaymentStatus(id).subscribe((response: PaymentStatus) => {
                switch (response) {
                    case PaymentStatus.Paid:
                        {
                            this.routerService.router.navigateByUrl(`/training/confirm/${id}`);
                            this.blockUi.stop();

                            this.notificationsService.success('Payment Successful',
                                'Secure 3D authorisation successful and payment made.');

                            break;
                        }
                    case PaymentStatus.Pending:
                        {
                            this.routerService.router.navigateByUrl(`/training/confirm/${id}`);
                            this.notificationsService.alert('Payment Pending',
                                'Secure 3D authorisation has not been received. Wait 5 minutes and then refresh the page.');
                            break;
                        }
                    default:
                        {
                            $('#payment-failed-modal').modal();
                            break;
                        }
                }
                this.blockUi.stop();
            },
                () => {
                    this.blockUi.stop();
                });
        });
    }

    redirectToPaymentPage() {
        $('#payment-failed-modal').modal('hide');
        this.routerService.router.navigateByUrl(`/training/confirm/`);
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/views/training/training.processing.component.ts